import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NavLink } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase"; // adjust path
import { logoutRestaurant } from "../services/auth"; // adjust path

export function MobileHeader() {

    const [menuOpen, setMenuOpen] = useState(false);

    const handleLogout = async () => {

        try {

            //--------------------------------------------------
            // Clear backend session
            //--------------------------------------------------

            await logoutRestaurant();

            //--------------------------------------------------
            // Sign out Firebase
            //--------------------------------------------------

            await signOut(auth);

            //--------------------------------------------------
            // Clear selected outlet
            //--------------------------------------------------

            localStorage.removeItem(

                "selectedOutletUid"

            );

            //--------------------------------------------------
            // Close menu
            //--------------------------------------------------

            setMenuOpen(false);

            //--------------------------------------------------
            // Redirect to login
            //--------------------------------------------------

            window.location.href = "/login";

        }

        catch (error) {

            console.error(

                "Failed to log out:",

                error

            );

        }

    };

    return (

        <>

            <header className="mobile-header">

                <div className="mobile-header-logo">

                    <img
                        src={require("./../imgs/nextgo-logo.png")}
                        alt="Next Go Logo"
                        className="mobile-header-logo-icon"
                    />

                    <span className="mobile-header-logo-text">
                        Next<span className="blue">Go</span>
                    </span>

                </div>

                <button
                    className="mobile-menu-btn"
                    onClick={() => setMenuOpen(true)}
                >

                    <Menu size={26} />

                </button>

            </header>

            <div
                className={`mobile-menu-overlay ${menuOpen ? "open" : ""
                    }`}
                onClick={() => setMenuOpen(false)}
            />

            <nav
                className={`mobile-sidebar ${menuOpen ? "open" : ""
                    }`}
            >

                <div className="mobile-sidebar-header">


                    <button
                        className="mobile-close-btn"
                        onClick={() => setMenuOpen(false)}
                    >

                        <X size={24} />

                    </button>

                </div>

                <NavLink
                    to="/overview"
                    onClick={() => setMenuOpen(false)}
                >
                    Overview
                </NavLink>

                <NavLink
                    to="/offers"
                    onClick={() => setMenuOpen(false)}
                >
                    Offers
                </NavLink>

                <NavLink
                    to="/wallet"
                    onClick={() => setMenuOpen(false)}
                >
                    Wallet
                </NavLink>

                <NavLink
                    to="/transactions"
                    onClick={() => setMenuOpen(false)}
                >
                    Transactions
                </NavLink>

                <NavLink
                    to="/integrations"
                    onClick={() => setMenuOpen(false)}
                >
                    Integrations
                </NavLink>

                <div className="mobile-sidebar-footer">
                    <button
                        className="mobile-logout-btn"
                        onClick={handleLogout}
                    >
                        Log Out
                    </button>
                </div>

            </nav>

        </>

    );

}